// Start the interactive, when the DOM is ready
document.addEventListener('DOMContentLoaded', function(){

	// Promise Polyfill - https://github.com/taylorhakes/promise-polyfill
	if ( !window.Promise ) {
		window.Promise = !function(e){function n(){}function t(e,n){return function(){e.apply(n,arguments)}}function o(e){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],s(e,this)}function i(e,n){for(;3===e._state;)e=e._value;return 0===e._state?void e._deferreds.push(n):(e._handled=!0,void o._immediateFn(function(){var t=1===e._state?n.onFulfilled:n.onRejected;if(null===t)return void(1===e._state?r:u)(n.promise,e._value);var o;try{o=t(e._value)}catch(i){return void u(n.promise,i)}r(n.promise,o)}))}function r(e,n){try{if(n===e)throw new TypeError("A promise cannot be resolved with itself.");if(n&&("object"==typeof n||"function"==typeof n)){var i=n.then;if(n instanceof o)return e._state=3,e._value=n,void f(e);if("function"==typeof i)return void s(t(i,n),e)}e._state=1,e._value=n,f(e)}catch(r){u(e,r)}}function u(e,n){e._state=2,e._value=n,f(e)}function f(e){2===e._state&&0===e._deferreds.length&&o._immediateFn(function(){e._handled||o._unhandledRejectionFn(e._value)});for(var n=0,t=e._deferreds.length;n<t;n++)i(e,e._deferreds[n]);e._deferreds=null}function c(e,n,t){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof n?n:null,this.promise=t}function s(e,n){var t=!1;try{e(function(e){t||(t=!0,r(n,e))},function(e){t||(t=!0,u(n,e))})}catch(o){if(t)return;t=!0,u(n,o)}}var a=setTimeout;o.prototype["catch"]=function(e){return this.then(null,e)},o.prototype.then=function(e,t){var o=new this.constructor(n);return i(this,new c(e,t,o)),o},o.all=function(e){var n=Array.prototype.slice.call(e);return new o(function(e,t){function o(r,u){try{if(u&&("object"==typeof u||"function"==typeof u)){var f=u.then;if("function"==typeof f)return void f.call(u,function(e){o(r,e)},t)}n[r]=u,0===--i&&e(n)}catch(c){t(c)}}if(0===n.length)return e([]);for(var i=n.length,r=0;r<n.length;r++)o(r,n[r])})},o.resolve=function(e){return e&&"object"==typeof e&&e.constructor===o?e:new o(function(n){n(e)})},o.reject=function(e){return new o(function(n,t){t(e)})},o.race=function(e){return new o(function(n,t){for(var o=0,i=e.length;o<i;o++)e[o].then(n,t)})},o._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){a(e,0)},o._unhandledRejectionFn=function(e){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)},o._setImmediateFn=function(e){o._immediateFn=e},o._setUnhandledRejectionFn=function(e){o._unhandledRejectionFn=e},"undefined"!=typeof module&&module.exports?module.exports=o:e.Promise||(e.Promise=o)}(this);
	}

	// Variables
	self.folder = 'interactives/2017/bpea-map/assets';
	self.mapFile = '/map.svg'; // SVG
	self.dataFile = '/data.json'; // JSON
	self.interactive = document.querySelector('#bpea-map')
	self.years = ['2000', '2014'];

	// Select the appropriate CDN URL
	self.cdn = 'https://c24215cec6c97b637db6-9c0895f07c3474f6636f95b6bf3db172.ssl.cf1.rackcdn.com/';
	if ( window.location.hostname !== 'www.brookings.edu' ){
		self.cdn = 'http://brookings-cdn.dev/';
	}
	self.cdn += self.folder;
	// console.log( 'CDN: ' + self.cdn );

	// Set the innerHTML property of a node, ensuring that whitespace is preserved even in IE8.
	function setInnerHTML( node, html ) {
		// First empty the node
		// while ( node.hasChildNodes() ) {
		// 	node.removeChild( node.lastChild );
		// }

		// IE does not have innerHTML for SVG nodes, so instead we inject the
		// new markup in a temp node and then move the child nodes across into
		// the target node
		let reusableSVGContainer = document.createElement( 'div' );
		reusableSVGContainer.innerHTML = `<svg>${ html }</svg>`;
		let svgNode = reusableSVGContainer.firstChild;
		while ( svgNode.firstChild ) {
			node.appendChild( svgNode.firstChild );
		}
	}

	// Request to get the CSV
	function getData( url, type ){

		// Return a new promise
		return new Promise( function( resolve, reject ){

			// Setup the request
			const xhr = new XMLHttpRequest();
			xhr.open( 'GET', url );
			xhr.responseType = type;

			//
			xhr.onload = function(){
				if ( 200 == xhr.status ){ resolve( xhr.response ); }
				else { reject( Error( `Error: ${ xhr.statusText }\nDidn't succeded to get: ${ url }` ) ); }
			}

			// Handle network errors
			xhr.onerror = function(){
				reject( Error( "Network Error\nDidn't succeded to get: " + url ) );
			}

			// Send the request
			xhr.send( null );

		});
	}

	// Create the full graph
	function drawMaps( svgMap ){

		// Create a map for each year
		for ( let year of self.years ){

			// Get the proper map
			let map = document.querySelector( '.map' + year );

			// Add the the US couties map
			setInnerHTML( map, svgMap );
		}
	}

	// Give a select colour to a county
	function colourMaps(){

		// Go trough each county and give them a random colour
		for ( let county in self.counties ) {

			let colour = '';
			let countySelector = county;
			if ( countySelector.length < 5 ){ countySelector = '0' + countySelector; }

			// Go trough all the years
			for ( let year of self.years ){

				// Get the value for the specific year
				let value = self.counties[ county ][ year ];
				if ( value === "0-25" ) { colour = 'leg-0-25'; }
				if ( value === "25-50" ) { colour = 'leg-25-50'; }
				if ( value === "50-75" ) { colour = 'leg-50-75'; }
				if ( value === "75-100" ) { colour = 'leg-75-100'; }
				if ( value === "100+" ) { colour = 'leg-100'; }

				// Get the county on the appropriate map
				let mapCounty = self.interactive.querySelector( `.map${ year } .c${ countySelector }` );

				// then give it the proper colour
				( null !== mapCounty && '' !== colour ) && mapCounty.classList.add( colour );
			}
		}
	}

	// Hide the maps before they are coloured
	function hideMaps(){
		for ( let year of self.years ){
			self.interactive.querySelector( '.map' + year + ' svg' ).setAttribute( 'class', 'hidden' );
		}
	}

	// Show the maps and hide the placeholder
	function showMaps(){
		for ( let year of self.years ){
			self.interactive.querySelector( '.map' + year + ' svg' ).setAttribute( 'class', '' );
			self.interactive.querySelector( '.map' + year + ' img' ).className = 'hidden';
		}
	}

	// Run the whole damn thing
	function app( data ){

		// Go get the SVG to create the maps
		getData( self.cdn + self.mapFile, 'text' ).then( function( data ){
			drawMaps( data );
			hideMaps();

			// Get the data
			getData( self.cdn + self.dataFile, 'json' ).then( function( data ){

				// Save the data
				self.counties = data;

				// And colour the map!
				colourMaps();
				showMaps();
			});
		});
	}
	app();

}, false ); // end of the interactive
